module.exports = __webpack_public_path__ + "static/img/logo-nhlife.b7c4f6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/logo-nhlife.png
// module id = 6s4r
// module chunks = 0